import * as React from 'react';
import {
    Box, Card, Chip, IconButton, Slider, Typography, CardMedia, Stack, Dialog,
    DialogContent,
    DialogTitle,

} from '@mui/material';
import '../Studio/Studio.css';
import CloseIcon from '@mui/icons-material/Close';
import { PlayArrow, Pause, Fullscreen, VideoSettings } from '@mui/icons-material';
import Popup from "../Popup/Popup";
import CircularProgress from '@mui/material/CircularProgress';
import { generateVideoId} from "../../services/apiService";
import { showToast } from '../Toast/CommonToast';
import { useReelsWebSocket} from "../../context/ReelWebSocketProvider";
import { useRambWalkWebSocket } from '../../context/RampWalkWebSocket';
import { useLocation } from 'react-router-dom';
import YouTubePopup from "../Popup/YouTubePopup/YoutubePopup";
import FluidComponent from '../Reusable/FluidComponent';
// import { useRambWalkWebSocket } from '../../context/RampWalkWebSocket';
import VideoComponent1 from '../VideoEditorEmbed';
import Tooltip from '@mui/material/Tooltip';
import ScheduledPopup from '../Popup/YouTubePopup/ScheduledPopup';

interface VideoComponentProps {
    image: any | null;
    setImage: (value: string | null) => void;
    videoData?: any | null;
    prompt: string;
    setPrompt: (value: string) => void;
    animationText?: string;
    setAllSearchImages: React.Dispatch<React.SetStateAction<any[]>>
    allSearchImages?: any | undefined;
    selectedAnimationKey?: string | null;
    animationLocation?: string  | undefined;
    sharePopup?: boolean;
    setSharePopup?: React.Dispatch<React.SetStateAction<boolean>>;
    setScheduledData?: React.Dispatch<React.SetStateAction<any[] | null>>;
    scheduledData?: any[] | null;
}

export default function VideoComponent({ setAllSearchImages, allSearchImages, videoData, sharePopup, setSharePopup, setScheduledData, scheduledData }: VideoComponentProps) {
    const videoRef = React.useRef<HTMLVideoElement | null>(null);
    const [viewType, setViewType] = React.useState<'grid' | 'masonry'>('masonry');
    const [playing, setPlaying] = React.useState(false);
    const [progress, setProgress] = React.useState(0);
    const [duration, setDuration] = React.useState(0);
    const [mainVideo, setMainVideo] = React.useState<string | undefined>(undefined);
    const [audioUrl, setAudioUrl] = React.useState<string | undefined>(undefined);
    const [videoiText, setVideoText] = React.useState<string>("");
    const [videoImage, setVideoImage] = React.useState<string>("");
    const [fullscreenPopup, setFullscreenPopup] = React.useState(false);
    const [modalPrompt, setModalPrompt] = React.useState<string>("");
    const [selectedImageId, setSelectedImageId] = React.useState<string | null>(null);
    const [popupOpen, setPopupOpen] = React.useState(false);
    const [selectedVideoIndex, setSelectedVideoIndex] = React.useState<number>(0);
    const [viewPopupOpen, setViewPopupOpen] = React.useState(false);
 
    const [selectedPopupItem, setSelectedPopupItem] = React.useState<any | null>(null);
    const location = useLocation();
    const [publishedData, setPublishedData] = React.useState<any>(null);
    const isReelsPage = location.pathname.startsWith('/studio/reels');
    const reelsWebSocket = useReelsWebSocket();
    const rampWalkWebSocket = useRambWalkWebSocket();
    const { responseData, status} = isReelsPage ? reelsWebSocket : rampWalkWebSocket
    const { state } = location;
      const isWsLoading = status === 'IN_PROGRESS';

    React.useEffect(() => {
        const youtubeLocation = localStorage.getItem('youtubeId');
        const locationPage = localStorage.getItem('youtubeLocation');
        if (youtubeLocation && allSearchImages.length > 0 && locationPage && state?.popup) {
            const idx = allSearchImages.findIndex((item:any) => item._id === youtubeLocation);
            if (idx !== -1) {
                setSelectedVideoIndex(idx);
              if(setSharePopup) setSharePopup(true);
                setSelectedPopupItem(allSearchImages[idx]);
            }
            localStorage.removeItem('youtubeLocation');
        }
    }, [location.pathname, allSearchImages, state?.popup]);
    const [openEditor, setOpenEditor] = React.useState(false);

    // const { responseData} = isReelsPage ? reelsWebSocket : rampWalkWebSocket

    // socker Response here
    React.useEffect(() => {
        if (responseData) {
            let responseArray = Array.isArray(responseData) ? responseData : [responseData];
            // Deduplicate by _id before merging
            responseArray = responseArray.filter((item, idx, arr) =>
                item._id ? arr.findIndex(i => i._id === item._id) === idx : true
            );
            if (responseArray.length > 0) {
                setAllSearchImages((prev: any) => {
                    const filtered = prev.filter((item: any) => item.status !== "IN_PROGRESS");
                    // Only add new items not already present by _id
                    const newItems = responseArray.filter(newItem =>
                        !filtered.some((existing:any) => existing._id === newItem._id)
                    );
                    return [...newItems, ...filtered];
                });
            }
        }
    }, [responseData, setAllSearchImages]);

    React.useEffect(() => {
      console.log("videoData", videoData)
      setMainVideo(videoData?.videoUrl || "")
      setVideoImage(videoData?.inputData?.image_url || videoData?.inputData?.imageUrl?.[0] || videoData?.inputData?.imageUrl || videoData?.inputData || "");
      setAudioUrl(videoData?.audioUrlTrim || "");
      setVideoText(videoData?.text || "");
      setModalPrompt(videoData?.inputData?.prompt || "");
      setSelectedImageId(videoData?._id || null);
      if (videoData && videoData._id) {
        setAllSearchImages(prev => {
          // Avoid duplicate
          const exists = prev.some(item => item._id === videoData._id);
          return exists ? prev : [videoData, ...prev];
        });
      }
    }, [videoData, setAllSearchImages]);
    

    React.useEffect(() => {
        if (allSearchImages.length && typeof selectedVideoIndex === 'number') {
            const selected = allSearchImages[selectedVideoIndex] || allSearchImages[0];
            setVideoImage(selected?.inputData?.image_url || selected?.inputData?.imageUrl || selected?.inputData || "");
            setMainVideo(selected?.videoUrl );
            setAudioUrl(selected?.audioUrlTrim || "");
            setVideoText(selected?.text || "");
            setModalPrompt(selected?.inputData?.prompt);
            setSelectedImageId(selected?._id);
                 const published = allSearchImages[selectedVideoIndex]?.published;
             let youtubeDataArr: any[] = [];
            if (published && typeof published === 'object' && Array.isArray(published.youtube) && published.youtube.length > 0) {
                youtubeDataArr = published.youtube;
            }
             setPublishedData(youtubeDataArr);
            if(selected?.status === "ERROR"){
                showToast(selected?.statusResponse?.payload?.detail[0]?.msg || selected?.statusResponse?.payload?.detail,'error')
            }
        }
    }, [allSearchImages, selectedVideoIndex]);



const togglePlayPause = async () => {
  if (videoRef.current) {
    const videoEl = videoRef.current;
    if (!videoEl.paused) {
      videoEl.pause();
      setPlaying(false);
    } else {
      try {
        await videoEl.play();
        setPlaying(true);
      } catch (error) {
        console.warn("Play request interrupted or blocked:", error);
      }
    }
  }
};

    const handleProgress = () => {
      if (videoRef.current) {
          const { currentTime, duration } = videoRef.current;
          if (!isFinite(currentTime) || !isFinite(duration) || duration === 0) return;
  
          setProgress((currentTime / duration) * 100);
      }
  };
  

    const handleSeek = (event: Event, newValue: number | number[]) => {
      if (videoRef.current) {
          const duration = videoRef.current.duration;
          if (!isFinite(duration)) return;
  
          const seekValue = Array.isArray(newValue) ? newValue[0] : newValue;
          videoRef.current.currentTime = (seekValue / 100) * duration;
          setProgress(seekValue);
      }
  };

    const handleLoadedMetadata = () => {
        if (videoRef.current) {
            setDuration(videoRef.current.duration);
        }
    };

    const formatTime = (time: number) => {
        const minutes = Math.floor(time / 60);
        const seconds = Math.floor(time % 60);
        return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    };
     

    const handleOpenPopup = (item:any) => {
        setMainVideo(item.videoUrl);
        setAudioUrl(item.audioUrlTrim || "");
        setPopupOpen(true);
    }
       const resetVideo = () => {
        if (videoRef.current) {
            videoRef.current.currentTime = 0;
            setProgress(0);
            setPlaying(false);
            videoRef.current.pause();
        }
    };

     const handleVideoSearch = async (id: any, idx?: number) => {
        resetVideo();
        // setOpenEditor(true);
        if (typeof idx === 'number') setSelectedVideoIndex(idx);
        try {
            const response = await generateVideoId(id);
            console.log("Response from generateVideoId:", response);
            if (response.status === "success") {
                const videoUrl =  response?.data?.videoUrl;
                const selectedPrompt = response?.data?.inputData?.prompt;
                setMainVideo(videoUrl);
                setAudioUrl(response?.data?.audioUrlTrim || "");
                setVideoText(response?.data?.text || "");
                setVideoImage(response?.data.inputData?.image_url || response?.data?.inputData?.imageUrl || response?.data?.inputData || "");
                setModalPrompt(selectedPrompt);
                setSelectedImageId(response.data._id);
                // setSelectedVideoIndex(idx) already called above
                if(response?.data?.status === "ERROR"){
                    showToast(response?.data?.statusResponse?.payload?.detail[0]?.msg || response?.data?.statusResponse?.payload?.detail,'error')
                }
            }
        } catch (error) {
            console.error("Error fetching video:", error);
        }
    };
    

    const handleDownload = async () => {
         try {
             // Placeholder: fetch video and audio
             let videoUrl = mainVideo || "";
             let audioUrls = audioUrl || "";
             let VideoText = videoiText || ""
             if (!videoUrl) {
                 return;
             }
             // Download video and audio blobs
             const videoBlob = await fetch(videoUrl).then(r => r.blob());
             // let audioBlob = null;
             if (audioUrl) {
               await fetch(audioUrls).then(r => r.blob());
             }
             if(VideoText){
              await fetch(VideoText).then(r => r.blob());
             }
             const url = window.URL.createObjectURL(videoBlob);
             const a = document.createElement("a");
             let fileName = videoUrl.split('/').pop()?.split('?')[0] || "podcast-video.mp4";
             if (!fileName.toLowerCase().endsWith('.mp4')) {
                 fileName += '.mp4';
             }
             a.href = url;
             a.download = fileName;
             document.body.appendChild(a);
             a.click();
             document.body.removeChild(a);
             window.URL.revokeObjectURL(url);
         } catch (error) {
             console.error("Download failed:", error);
         }
     };
      const handleSharePopup = (item: any) => {
         if (setSharePopup) setSharePopup(true);
        setSelectedPopupItem(item);
        localStorage.setItem('youtubeLocation', location.pathname)
        localStorage.setItem('youtubeId', item._id);
    }
    

    return (
       <Box className="videoComponentContainer">

        <Dialog open={openEditor} onClose={() => setOpenEditor(false)}
        maxWidth={false}
        PaperProps={{
          sx: {
            width: '90vw',
            height: '90vh',
            maxWidth: 'none',
            maxHeight: 'none',
            minWidth: 300,
            minHeight: 300,
            borderRadius: 3,
          },
        }}
        >
          <DialogTitle>
            Showcasaai Video Editor
            <IconButton onClick={() => setOpenEditor(false)} style={{ position: 'absolute', right: 8, top: 8 }}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <VideoComponent1 projectId={videoData?._id || ""} url={mainVideo || ""} />
          </DialogContent>
        </Dialog>

        {allSearchImages.length > 0 ? (
          <Box sx={{position: 'relative'}}>
            {mainVideo ? (
              <Card className="videoCard">
                <Box style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 2, flexDirection: 'row' , height: '100%'}}>
                  {isReelsPage && (
                    <Box className=''>
                     <Tooltip title="Video Editor" arrow>
                      <IconButton onClick={() => setOpenEditor(true)} sx={{background: '#363333', borderRadius: 0, px: 0.5, py: 0.25}} >
                        <VideoSettings />
                      </IconButton>
                    </Tooltip>
                  </Box>
                  )}
                  <Box className=''>
                    <IconButton onClick={() => setViewPopupOpen(true)}>
                      <img src={'/assets/VideoEye.svg'} alt='viewIcon' className='viewIcon' />
                    </IconButton>
                  </Box>
                  <Box className="">
                    <IconButton onClick={handleDownload}>
                      <img
                        src={'/assets/DownloadIcon.svg'}
                        alt="downloadIcon"
                        className="downloadIcon"
                      />
                    </IconButton>
                  </Box>
                  <Box className=''>
                    <IconButton onClick={() => handleSharePopup(allSearchImages[selectedVideoIndex])}>
                      <img src={'/assets/ShareIcon.svg'} alt='shareIcon' className='shareIcon' />
                    </IconButton>
                  </Box>
                </Box>
                <Box className="videoWrapper">
                  <video
                    key={mainVideo}
                    ref={videoRef}
                    loop
                    // muted
                    onTimeUpdate={handleProgress}
                    playsInline
                    onLoadedMetadata={handleLoadedMetadata}
                    poster={videoImage}
                  >
                    <source src={mainVideo ?? undefined} type="video/mp4" />
                  </video>
                </Box>
               
                                                                         {sharePopup && (
                                                <YouTubePopup
                                                        isOpen={sharePopup}
                                                        onClose={() => {  if (setSharePopup) setSharePopup(false); setSelectedPopupItem(null); }}
                                                        videoUrl={selectedPopupItem?.videoUrl || mainVideo || ''}
                                                        titlePage="Podcast"
                                                        selectedPopupItem={selectedPopupItem}
                                                    />    
                                                )}
                <Box className="videoControls">
                  <IconButton onClick={togglePlayPause}>
                    {playing ? <Pause /> : <PlayArrow />}
                  </IconButton>
                  <Slider
                    value={progress}
                    onChange={handleSeek}
                    className="videoSlider"
                  />
                  <Typography variant="body2" className="videoTime">
                    {formatTime(duration)}
                  </Typography>
                  <IconButton onClick={() => setFullscreenPopup(true)}>
                    {" "}
                    {/* Open fullscreen popup */}
                    <Fullscreen />
                  </IconButton>
                  {fullscreenPopup && (
                    <Dialog
                      open={fullscreenPopup}
                      onClose={() => setFullscreenPopup(false)}
                      maxWidth="lg"
                      fullWidth
                      className="modalContainer"
                    >
                      <DialogTitle className="closeIconContainer">
                        <IconButton
                          onClick={() => setFullscreenPopup(false)}
                          className="closeIconbutton"
                        >
                          <CloseIcon />
                        </IconButton>
                      </DialogTitle>
                      <DialogContent>
                        <Box
                          sx={{width: "100%",height: "60%",position: "relative",}}
                        >
                          <video
                            controls
                            autoPlay
                            loop
                            muted
                            className="modalVideo"
                            controlsList="nodownload"
                          >
                            <source src={mainVideo} type="video/mp4" />
                          </video>
                          <Box className="videoHeader">
                            <IconButton onClick={handleDownload}>
                              <img
                                src={'/assets/DownloadIcon.svg'}
                                alt="downloadIcon"
                                className="downloadIcon"
                              />
                            </IconButton>
                          </Box>
                          {/* <Box className="videoFooter">
                            <img
                              src={waterMarkImage}
                              alt="waterMarkIcon"
                              className="waterMarkIcon"
                            />
                          </Box> */}
                        </Box>

                      </DialogContent>
                    </Dialog>
                  )}
                </Box>              
              </Card>
            ) : (
              <Box className="videoUploadCard">
                <CardMedia
                  component="img"
                  image={videoImage}
                  className={
                    videoData?.isGenerated 
                      ? "videoCardImage"
                      : "blurImage"
                  }
                />
                <div className="videoLoadingContainer">
                  {videoData?.status === "IN_PROGRESS" && (
                    <CircularProgress size={24} className="videoLoadingIcon" />
                  )}
                </div>
              </Box>
            )}
            {/* <Box className="videoDescription">
              <Typography variant="h6" className="videoTitle">
                Video Generated
              </Typography>
              <Chip
               label={
                (Array.isArray(allSearchImages)
                  ? allSearchImages.filter((item: any) => item?.isGenerated).length
                  : 0) ||
                (Array.isArray(videoData)
                  ? videoData.filter((item: any) => item?.isGenerated).length
                  : 0)
              }
                className="videoChip"
              />
            </Box> */}
            <Box className="videoThumbnails">
               {allSearchImages.length > 0 && (
                <FluidComponent
                items={allSearchImages.map((item: any) => ({
                  ...item,
                  thumbnailUrl: item?.thumbnailUrl || item?.inputData?.imageUrl || '',
                }))}
                selectedIndex={selectedVideoIndex}
                onSelect={(idx: number) => {
                  setSelectedImageId(allSearchImages[idx]._id);
                  handleVideoSearch(allSearchImages[idx]._id);
                  setSelectedVideoIndex(idx);
                }}
                isLoading={isWsLoading}
                onPromptClick={handleOpenPopup}
                viewType={viewType}
                setViewType={setViewType}
                headingText={isReelsPage ? "Reels Video Generated" : "Ramp Walk Video Generated"}
                chips={allSearchImages?.map((item:any)=>item.isGenerated).length}
              />
               )}
            </Box>
               <Dialog open={viewPopupOpen} onClose={() => setViewPopupOpen(false)} >
                                <Box className="PopupHeader">
                                    <IconButton onClick={() => setViewPopupOpen(false)} className="PopupCloseButton">
                                        <CloseIcon />
                                    </IconButton>
                                </Box>
                                <DialogTitle>Publish Youtube Info</DialogTitle>
                                <DialogContent>
                                    <Box sx={{ minWidth: 250, p: 1 }}>
                                        {Array.isArray(publishedData) && publishedData.length > 0 ? (
                                            publishedData.map((entry: any, idx: number) => (
                                                <Box key={idx} sx={{ mb: 2 }}>
                                                    <Typography variant="body1" className='videoPromptText'>
                                                        Channel Name:<Typography variant='body1'>{entry.details?.snippet?.channelTitle || entry.channelId || ''}</Typography>
                                                    </Typography>
                                                    <Typography variant="body1" className='videoPromptText'>
                                                        Published Status:<Typography variant='body1'>{entry.status || ''}</Typography>
                                                    </Typography>
                                                    <Typography variant="body1" className='videoPromptText'>
                                                        Published Url: <Typography
                                                            variant="body1"
                                                            className="linkTextyoutube"
                                                            style={{ cursor: entry.youtubeUrl ? 'pointer' : 'default', color: entry.youtubeUrl ? '#1976d2' : undefined }}
                                                            onClick={() => {
                                                                if (entry.youtubeUrl) window.open(entry.youtubeUrl, '_blank');
                                                            }}
                                                        >
                                                            {entry.youtubeUrl || ''}
                                                        </Typography>
                                                    </Typography>
                                                </Box>

                                            ))
                                        ) : (
                                            <Typography variant="body1">No YouTube publish info available.</Typography>
                                        )}
                                    </Box>
                                </DialogContent>
                            </Dialog>
          </Box>
        ) : (
          <Card className="videoPlaceholderCard">
            <Box className="videoPlaceholderContent">
              <img
                src={'/assets/ContentVideo.svg'}
                alt="contentVideo"
                className="videoPlaceholderIcon"
              />
              <Typography variant="body1" className="videoPlaceholderText">
                Create your ideas now.
              </Typography>
              <Typography variant="body1" className="videoPlaceholderText">
                Generated videos will appear here
              </Typography>
            </Box>
          </Card>
        )}

        {/* {popup} */}
        {popupOpen && (
          <Popup
            open={popupOpen}
            onClose={() => setPopupOpen(false)}
            rightColumnType='video'
            leftColumnType='both'
            leftImageSrc={videoImage}
            mainVideo={mainVideo}
            leftPromptText={modalPrompt}
            audioUrl={audioUrl}
          />

        )}
        {Array.isArray(scheduledData) && scheduledData.length > 0 && (
          <ScheduledPopup
            open={true}
            onClose={() => {
              if (setScheduledData) setScheduledData(null);
            }}
            scheduledData={scheduledData}
          />
        )}
      </Box>
    );
}
